
import * as R from 'ramda';

export default function ArchivedReportsController(
  $q,
  $scope,
  $rootScope,
  $filter,
  userService,
  reportsDataService,
) {
  const vm = this;
  
  vm.reportInstanceTypes = [];
  vm.hasReportInstanceTypes = false;

  vm.filteredReportInstanceTypes = [];
  vm.hasFilteredReportInstanceTypes = false;
  
  vm.filterReportCategories = [];
  vm.filterReportNames = [];
  vm.filterReportOwnerNames = [];

  vm.showFilters = true;  

  vm.filter = {
    category: -1,
    reportName: -1,
    reportOwner: -1,
  };

  vm.handleClearFilters = _handleClearFilters;
  vm.handleFilterChange = _handleFilterChange;

  _activate();

  /** ********************************************
   * Event Handlers
   */

  $scope.$on('reports.archivedReports.reportTypeEmpty', (event, reportType) => {
    _handleDeletedReportType(reportType);
  });

  /** ********************************************
   * Private Functions
   */

  function _activate() {
    vm.appIsLoaded = false;
    vm.showFilters = true;
   
    const promises = [
      _loadCustomerId(),
      reportsDataService.getArchivedReportInstanceSummary()
    ];

    return $q.all(promises).then((response) => {
      
      vm.reportInstanceTypes = response[1].data.result;
      vm.hasReportInstanceTypes = vm.reportInstanceTypes.length > 0;

      _extractFilterReportCategories(vm.reportInstanceTypes);
      _extractFilterReportNames(vm.reportInstanceTypes);
      _extractFilterReportOwners(vm.reportInstanceTypes);

      _setDefaultInstanceValues();

      _handleFilterChange();

      vm.appIsLoaded = true;
    });
  }

  function _handleDeletedReportType(reportType) {
    _remove(vm.filteredReportInstanceTypes);
    _remove(vm.reportInstanceTypes);

    function _remove(collection) {
      const pos = collection.findIndex(item => item.uniqueId === reportType.uniqueId);
      if (pos === -1) {
        return; // Can't find the item
      }
      collection.splice(pos, 1);
    }
    
    _extractFilterReportCategories(vm.reportInstanceTypes);
    _extractFilterReportNames(vm.reportInstanceTypes);
    _extractFilterReportOwners(vm.reportInstanceTypes);

    _handleFilterChange();
  }
  
  function _loadCustomerId() {
    return userService.getUser().then((user) => {
      vm.customerId = user.customerId;
      vm.userId = user.userId;
      vm.userName = user.userName;
    });
  }

  function _extractFilterReportCategories(reportInstanceTypes) {
    const _categories = [];
    const _categoryIds = [];

    R.forEach((reportInstanceType) => {
      let _found = false;
      const _categoryId = reportInstanceType.familyId;
      const _categoryName = reportInstanceType.familyName;

      R.forEach((categoryId) => {        
        if (categoryId === _categoryId) {
          _found = true;
        };
      }, _categoryIds);

      if (!_found) {
        const category = {
          id: _categoryId,
          name: _categoryName,
        };
        _categories.push(category);
        _categoryIds.push(_categoryId);
      }
    }, reportInstanceTypes);

    vm.filterReportCategories = R.sortBy(R.compose(R.toLower, R.prop('name')), _categories);
  }

  function _extractFilterReportNames(reportInstanceTypes) {
    const _reportNames = [];
    const _reportIds = [];

    R.forEach((reportInstanceType) => {
      let _found = false;
      const _reportId = reportInstanceType.reportId;
      const _reportName = reportInstanceType.reportName;

      R.forEach((reportId) => {        
        if (reportId === _reportId) {
          _found = true;
        };
      }, _reportIds);

      if (!_found) {
        const reportName = {
          id: _reportId,
          name: _reportName,
        };
        _reportNames.push(reportName);
        _reportIds.push(_reportId);
      }
    }, reportInstanceTypes);

    vm.filterReportNames = R.sortBy(R.compose(R.toLower, R.prop('name')), _reportNames);
  }

  function _extractFilterReportOwners(reportInstanceTypes) {
    const _owners = [];
    const _ownerNames = [];
    
    R.forEach((reportInstanceType) => {
      if (reportInstanceType.reportOwners != null) {
        R.forEach((reportOwner) => {          
          let _found = false;
          const _ownerName = reportOwner.ownerName;

          R.forEach((ownerName) => {        
            if (ownerName === _ownerName) {
              _found = true;
            };
          }, _ownerNames);

          if (!_found) {
            const owner = {
              id: _ownerName,
              name: _ownerName,
            };
            _owners.push(owner);
            _ownerNames.push(_ownerName);
          }
        }, reportInstanceType.reportOwners);
      }
    }, reportInstanceTypes);

    vm.filterReportOwnerNames = R.sortBy(R.compose(R.toLower, R.prop('name')), _owners);
  }

  function _handleClearFilters() {
    vm.filter.category = -1;
    vm.filter.reportName = -1;
    vm.filter.reportOwner = -1;

    _handleFilterChange();
  } 

  function _handleFilterChange() {
    let _filteredReportInstanceTypes = vm.reportInstanceTypes;

    // These are filters for report types
    if (vm.filter.category !== -1) {
      _filteredReportInstanceTypes = $filter('filter')(_filteredReportInstanceTypes, { familyId: vm.filter.category });
    }

    if (vm.filter.reportName !== -1) {
      _filteredReportInstanceTypes = $filter('filter')(_filteredReportInstanceTypes, { reportName: vm.filter.reportName });
    }

    // These are filters for report instances
    if (vm.filter.reportOwner !== -1) {
      const _frpits = [];
      R.forEach((filteredReportInstanceType) => {   
        if (filteredReportInstanceType.reportOwners !== null) {
          let _found = false;

          R.forEach((reportOwner) => {        
            if (reportOwner.ownerName === vm.filter.reportOwner) {
              _found = true;
              filteredReportInstanceType.numberOfInstances = reportOwner.numberOfInstances; 
              filteredReportInstanceType.numberOfDeleteableInstances = reportOwner.numberOfDeleteableInstances; 
            };
          }, filteredReportInstanceType.reportOwners);

          if (_found) {
            _frpits.push(filteredReportInstanceType);
          }
        }
      }, _filteredReportInstanceTypes);

      _filteredReportInstanceTypes = _frpits;      
    } else {
       R.forEach((filteredReportInstanceType) => {   
        filteredReportInstanceType.numberOfInstances = filteredReportInstanceType.totalNumberOfInstances; 
        filteredReportInstanceType.numberOfDeleteableInstances = filteredReportInstanceType.totalNumberOfDeleteableInstances; 
      }, _filteredReportInstanceTypes);
    }

    _extractFilterReportNames(_filteredReportInstanceTypes);
    _extractFilterReportOwners(_filteredReportInstanceTypes);
        
    $rootScope.$broadcast('reports.archivedReports.updateReportInstancesReportOwner', { reportOwner: vm.filter.reportOwner.toString() });

    vm.filteredReportInstanceTypes = _filteredReportInstanceTypes;

    if (vm.filteredReportInstanceTypes !== null) {
      vm.hasFilteredReportInstanceTypes = vm.filteredReportInstanceTypes.length > 0;
    }
  }

  function _setDefaultInstanceValues() {
    R.forEach((filteredReportInstanceType) => {   
      filteredReportInstanceType.totalNumberOfInstances = filteredReportInstanceType.numberOfInstances; 
      filteredReportInstanceType.totalNumberOfDeleteableInstances = filteredReportInstanceType.numberOfDeleteableInstances; 
    }, vm.reportInstanceTypes);
  }
}

ArchivedReportsController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  '$filter',
  'userService',
  'reportsDataService'
];
